import * as React from 'react';

const ItemSubtitle = () => (
    <div className="w-full text-center text-xs transition-colors duration-1000 select-none ">
        Subtitle
    </div>
);

export default ItemSubtitle;
